module.exports = __webpack_public_path__ + "img/img_cx.c1b5fbba.jpg";